import { createReducer, getUpdater } from '@advanza/advanza_generic'
import { changeEntity, changeFilter, invalidateFilters, receiveList } from './sharedReducerHandlers'

const update = getUpdater()

const handlers = {
    PROVIDERSBANS_RECEIVE_LIST: receiveList,
    PROVIDERSBANS_CHANGE_FILTER: changeFilter,
    CHANGE_ENTITY_PROVIDERSBANS: changeEntity,
    INVALIDATE_PROVIDERSBANS: invalidateFilters,
    PROVIDERSBANS_REQUEST: (state) =>
        update(state, {
            isFetching: { $set: true },
        }),
}

const initialState = {
    isFetching: false,
    didInvalidate: false,
    counts: {},
    entities: {},
    result: {},
    filters: {},
}

export default createReducer(initialState, handlers)
